import { streamId } from "./stream-id";

export const streamIds = {
  type: "array",
  minItems: 0,
  maxItems: 1_000,
  items: streamId
};
